import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { meemoPageMeta, meemoSchema } from 'components/common/schema'
import Template from 'components/cases/meemo'

const Meemo: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...meemoPageMeta} />
      <JsonLd data={meemoSchema} />
      <Template />
    </>
  )
}

export default Meemo
